import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ErrorCode } from '@api';
import { AuthenticationErrorHandler } from '@api/errors/handlers/authentication-error.handler';
import { TechnicalErrorHandler } from '@api/errors/handlers/technical-error.handler';
import { AppError, HandledAppError } from '@api/errors/models/app-error.types';
import { catchError, throwError } from 'rxjs';

const TECHNICAL_ERRORS_EXCEPTIONS: readonly ErrorCode[] = ['EXT_IPPER_UNAVAILABLE']; // some 5xx errors have specific feature-level messages

export const appErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authenticationErrorHandler = inject(AuthenticationErrorHandler);
  const technicalErrorHandler = inject(TechnicalErrorHandler);

  return next(req).pipe(
    catchError((httpError: unknown) => {
      if (!(httpError instanceof HttpErrorResponse)) {
        return throwError(() => httpError);
      }

      const error = AppError.fromHttpError(httpError);
      console.error(`[API ${error.status}] ${httpError.url} - ${error.code ?? httpError.message}`);

      switch (error.kind) {
        case 'authentication':
          void authenticationErrorHandler.handle(error);
          return throwError(() => new HandledAppError(error));
        case 'network':
        case 'technical':
          if (error.code && TECHNICAL_ERRORS_EXCEPTIONS.includes(error.code)) break;
          technicalErrorHandler.handle(error);
          return throwError(() => new HandledAppError(error));
      }

      return throwError(() => error);
    }),
  );
};
